import React, { lazy } from 'react'
import { FrontUrls } from 'Src/constants/FrontUrls'
import { LazyRoute } from 'Modules'
import { Switch } from 'react-router-dom'

const SurveyListContainerLazy = lazy(() => import('Pages/survey/components/Survey/SurveyList'))
const SurveyAddContainerLazy = lazy(() => import('Pages/survey/components/Survey/CreateSurvey'))
const SurveyEditContainerLazy = lazy(() => import('Pages/survey/components/Survey/EditSurvey'))
const SurveyViewContainerLazy = lazy(
	() => import('Pages/survey/components/Questions/SurveyQuestionView/SurveyQuestionsViewWrapper')
)
const SurveyResultsContainerLazy = lazy(
	() => import('Pages/survey/components/Results/SurveyResultWrapper')
)
const SurveyCompleteContainerLazy = lazy(() => import('Pages/survey/components/Survey/Complete'))

export const SurveyRoutes = () => {
	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.survey.survey_create}
				lazyComponent={SurveyAddContainerLazy}
				key={FrontUrls.survey.survey_create}
			/>
			<LazyRoute
				path={FrontUrls.survey.survey_edit}
				lazyComponent={SurveyEditContainerLazy}
				key={FrontUrls.survey.survey_edit}
			/>
			<LazyRoute
				path={FrontUrls.survey.survey_view_question}
				lazyComponent={SurveyViewContainerLazy}
				key={FrontUrls.survey.survey_view_question}
			/>
			<LazyRoute
				path={FrontUrls.survey.survey_answers}
				lazyComponent={SurveyResultsContainerLazy}
				key={FrontUrls.survey.survey_answers}
			/>
			<LazyRoute
				path={FrontUrls.survey.survey_complete}
				lazyComponent={SurveyCompleteContainerLazy}
				key={FrontUrls.survey.survey_complete}
			/>
			<LazyRoute
				path={FrontUrls.survey.survey_short_link}
				lazyComponent={SurveyViewContainerLazy}
				key={FrontUrls.survey.survey_short_link}
			/>
			<LazyRoute
				exact
				path={FrontUrls.survey.index}
				lazyComponent={SurveyListContainerLazy}
				key={FrontUrls.survey.index}
			/>
		</Switch>
	)
}
